import React, { useEffect, useState } from "react";
import { RCCButton, RCCGrid, RCCTooltip } from "react-common-components";
import {  useLocation } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import { getLocalStorage, setLocalStorage } from "src/utils/localStorage";
import Panel from "../Panel";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Container, Main, styledButton } from "./styles";

const Shared: React.FC = ({
	children
}) => {
	const [fullScreenMode, setFullScreenMode] = useState(getLocalStorage("FSMode") === "true");
	const { translate } = useTranslation();
	const location = useLocation();
	const [locationState, setLocationState] = useState(location);


	const closeFSMode = () => {
		setLocalStorage("FSMode", "false");
		setFullScreenMode(false);
		document.removeEventListener("keydown", escFunction, false);
	};

	const escFunction = (event: any) => {
		if(event.keyCode !== 27) 
			return;

		closeFSMode();
	};

	if(fullScreenMode)
		document.addEventListener("keydown", escFunction, false);

	useEffect(() => {
		const {state} : any = location;
		if(state?.refresh)
			setLocationState(location);
	}, [location]);

	return(
		<Container>
			
			{!fullScreenMode && ( <Sidebar /> )}
			<Main fullScreenMode={fullScreenMode}>
				{!fullScreenMode && (
					<Header actionFullScreenButton={() => {
						setLocalStorage("FSMode", "true");
						setFullScreenMode(true);
					}}/>
				)}
				<Panel key={locationState.key} styleInline="width: calc(100% - 1rem);">
					{children}
				</Panel>
			</Main>
			{fullScreenMode && (
				<RCCGrid
					styleInline={styledButton}
				>
					<RCCTooltip
						color="grey"
						text={`${translate("Sair")} ${translate("Tela cheia")}`}
					>
						<RCCButton 
							color="grey"
							layout="isRounded"
							size="md"
							icon={{
								name: "arrowsCompress", 
								size: 16,
								color: "#FFF"
							}}
							onClick={() => closeFSMode()}
						/>
					</RCCTooltip>
				</RCCGrid>
			)}
		</Container>
	);};

export default Shared;
